import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Linkedin, Instagram } from 'lucide-react';
import logoIcon from '../../assets/logo-icon.png';
import logoWordmark from '../../assets/logo-wordmark.png';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-flex items-center gap-2 sm:gap-3">
              <img
                src={logoIcon}
                alt=""
                aria-hidden="true"
                className="h-12 sm:h-14 md:h-16 w-auto"
              />
              <img
                src={logoWordmark}
                alt="VehiMax - Todos los Vehículos. Una Plataforma"
                className="h-7 sm:h-8 md:h-9 w-auto rounded-sm"
              />
            </Link>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">El marketplace líder de vehículos comerciales. Compra, vende e intercambia camiones, remolques, maquinaria y más.</p>
            <div className="flex gap-3">
              <a href="#" className="p-2 bg-white/10 hover:bg-accent transition-colors rounded-sm" data-testid="social-facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 bg-white/10 hover:bg-accent transition-colors rounded-sm" data-testid="social-x" aria-label="X (Twitter)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="h-4 w-4"
                  aria-hidden="true"
                >
                  <path d="M18.244 2H21l-6.545 7.48L22.5 22h-6.828l-5.35-6.99L4.2 22H1.44l7.02-8.02L1.5 2h6.997l4.83 6.39L18.244 2zm-1.196 18.4h1.9L7.048 3.5H5.02L17.048 20.4z" />
                </svg>
              </a>
              <a href="#" className="p-2 bg-white/10 hover:bg-accent transition-colors rounded-sm" data-testid="social-linkedin">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="p-2 bg-white/10 hover:bg-accent transition-colors rounded-sm" data-testid="social-instagram">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-4">Enlaces rápidos</h4>
            <ul className="space-y-2">
              {[
                { to: '/browse', label: 'Explorar anuncios' },
                { to: '/browse?category=trucks', label: 'Camiones' },
                { to: '/browse?category=trailers', label: 'Remolques' },
                { to: '/browse?category=equipment', label: 'Maquinaria' },
                { to: '/browse?featured=true', label: 'Vehículos destacados' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-foreground/70 hover:text-accent transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For Sellers */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-4">Para vendedores</h4>
            <ul className="space-y-2">
              {[
                { to: '/register?role=seller', label: 'Vender como particular' },
                { to: '/register?role=dealer', label: 'Programa de concesionarios' },
                { to: '/pricing', label: 'Planes y precios' },
                { to: '/listings/create', label: 'Publica tu vehículo' },
                { to: '/help/selling', label: 'Guía para vender' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-foreground/70 hover:text-accent transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold uppercase tracking-wide mb-4">Contáctanos</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-primary-foreground/70">
                <Mail className="h-4 w-4 text-accent flex-shrink-0" />
                <a href="mailto:info@vehimax.com" className="hover:text-accent transition-colors" data-testid="footer-email-link">
                  info@vehimax.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-primary-foreground/50">
            &copy; {new Date().getFullYear()} Vehimax. Todos los derechos reservados.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-sm text-primary-foreground/50 hover:text-accent transition-colors">Política de privacidad</Link>
            <Link to="/terms" className="text-sm text-primary-foreground/50 hover:text-accent transition-colors">Términos del servicio</Link>
            <Link to="/cookies" className="text-sm text-primary-foreground/50 hover:text-accent transition-colors">Política de cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
